import { BookOpen } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { DailyQuiz } from "@/components/DailyQuiz";
import { Card, PageTitle } from "@/components/Layout";
import { GUIDE, GENERAL_TIPS } from "@/lib/learn";

export default function Learn() {
  const { t } = useApp();
  return (
    <div className="space-y-4">
      <PageTitle sub={t("Simple steps to get your scrap ready, so pickups are quick and you get the right rate.")}>{t("Pickup guide")}</PageTitle>
      <Card className="space-y-2" data-testid="guide-general">
        <h2 className="flex items-center gap-2 font-display text-lg font-bold text-[#0D3B2B]"><BookOpen className="h-5 w-5 text-[#2E9E6B]" />{t("Before every pickup")}</h2>
        <ul className="ml-5 list-disc space-y-1 text-sm text-[#4A6358]">{GENERAL_TIPS.map((x) => <li key={x}>{t(x)}</li>)}</ul>
      </Card>
      {GUIDE.map((g) => (
        <Card key={g.key} className="space-y-2" data-testid={`guide-${g.key}`}>
          <h3 className="font-bold text-[#0D3B2B]">{t(g.title)}</h3>
          <ul className="ml-5 list-disc space-y-1 text-sm text-[#4A6358]">{g.tips.map((x) => <li key={x}>{t(x)}</li>)}</ul>
        </Card>
      ))}
      <DailyQuiz />
    </div>
  );
}
